<template>
  <div>
    <div class="row animated fadeInRightBig">
      <div class="col-md-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Programação</h5>
            <div class="ibox-tools">
              <a class="dropdown-toggle" href="#" data-toggle="modal" data-target="#modal-filter">
                <i class="fa fa-filter"></i> Filtros
              </a>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-md-12 m-t-sm m-b-sm"></div>
              <div class="col-md-12">
                <full-calendar
                  ref="calendar"
                  @event-selected="eventClick"
                  :config="config"
                  :events="events"
                >
                <template v-slot:eventContent='arg'>
          
                  <i>{{ arg }}</i>
                </template>
              </full-calendar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="modal-filter" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content animated fadeIn">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
            <h4 class="modal-title">Filtros</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 form-group">
                <label for="theme_category_id">Categoria de Tema</label>
                <select
                  class="form-control"
                  id="theme_category_id"
                  v-model="filters.theme_category_id"
                >
                  <option value selected>Todos os Temas</option>
                  <option
                    :value="category.id"
                    v-for="(category, index) in themeCategories"
                    :key="index"
                  >{{ category.description }}</option>
                </select>
              </div>
              <div class="col-md-6 form-group">
                <label>Data de Cadastro - Inicial</label>
                <input type="date" name id class="form-control" v-model="filters.initialDate" />
              </div>
              <div class="col-md-6 form-group">
                <label>Data de Cadastro - Final</label>
                <input type="date" name id class="form-control" v-model="filters.finalDate" />
              </div>
              <div class="col-md-6 form-group">
                <label>Data de Apresentação - Inicial</label>
                <input type="date" name id class="form-control" v-model="filters.presentationDate" />
              </div>
              <div class="col-md-6 form-group">
                <label>Data de Apresentação - Final</label>
                <input
                  type="date"
                  name
                  id
                  class="form-control"
                  v-model="filters.presentationFinalDate"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              <i class="fa fa-close"></i> Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="filter">
              <i class="fa fa-check"></i> Aplicar Filtros
            </button>
          </div>
        </div>
      </div>
    </div>

    <detail-modal
      :enableDelete="false"
      :selectedEvent="selectedEvent"
      :selectedEvents="selectedEvents"
    ></detail-modal>
  </div>
</template>

<script>
import { FullCalendar } from "vue-full-calendar";
import DetailModal from "./DetailModal";

export default {
  data: function() {
    return {
      events: [],
      themeCategories: [],
      selectedEvents: {},
      selectedEvent: {},
      filters: {
        paginated: false,
        theme_category_id: "",
        initialDate: "",
        finalDate: "",
        presentationDate: "",
        presentationFinalDate: ""
      },
      config: {
        locale: "pt-BR",
        timezone: "UTC",
        defaultView: "month",
        header: {
          left: "title",
          center: "",
          right: "today prev,next"
        },
        buttonText: {
          today: "Hoje"
        },
        displayEventTime: false,
        editable: false,
        droppable: false,
        eventRender: function(eventObj, $el) {}
      }
    };
  },
  methods: {
    eventClick: function(event, jsEvent, view) {
      let self = this;
      let api = self.$store.getters.api + "events?paginated=false";

      self.$http
        .get(api, {
          params: {
            dds_date: event.start.format("YYYY-MM-DD") + " 00:00:00",
            with: [
              "theme",
              "teams_shifts",
              "teams_shifts.team",
              "teams_shifts.shift",
              "status"
            ]
          }
        })
        .then(response => {
          this.selectedEvents = response.data.data;
          this.selectedEvent = event;
        });

      $("#detailModal").modal("show");
    },
    getEvents: function() {
      const self = this;
      const api = self.$store.state.api + "events/scheduled";

      self.$http
        .get(api, {
          params: this.filters
        })
        .then(response => {
          self.events = response.data;
        })
        .catch(error => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
    },
    getThemeCategories: function() {
      const self = this;
      const api = self.$store.state.api + "theme-categories?paginated=false";

      self.$http.get(api).then(response => {
        self.themeCategories = response.data.data;
      });
    },

    filter: function() {
      this.getEvents();
      $("#modal-filter").modal("hide");
    }
  },
  components: {
    FullCalendar,
    DetailModal
  },
  mounted() {
    this.getThemeCategories();
    this.getEvents();
    //this.eventClick();
  }
};
</script>

<style>
.ibox-tools a {
  cursor: pointer;
  margin-left: 5px;
  color: #676a6c;
}

.fc-event,
.fc-agenda .fc-event-time,
.fc-event a {
  padding: 4px 6px;
}

select.input-lg,
.input-group-lg > select.form-control,
.input-group-lg > select.input-group-addon,
.input-group-lg > .input-group-btn > select.btn {
  height: 44px;
  line-height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/components/Schedule/Programming.vue